import { MyCohortPreviewMember } from '@platform/client/schemas';
import { AvatarNew } from '@platform/components';
import cx from 'classix';

export const ProAvatarArray = ({
  members,
  totalCount,
}: {
  members: MyCohortPreviewMember[];
  totalCount: number;
}) => {
  const displayMoreMembersAvatar = members.length < totalCount;
  const additionalCount = totalCount - members.length;
  return (
    <div className='flex items-center gap-2'>
      {/* Negative space-x AND dynamic z-index create the fanned avatar effect left to right */}
      <div className='flex items-center -space-x-5'>
        {members.map((user, index) => (
          <div
            key={index}
            className='border-2 border-white rounded-full'
            style={{ zIndex: members.length - index }}
          >
            <AvatarNew size='md' url={user.avatarUrl} name={user.firstName + ' ' + user.lastName} />
          </div>
        ))}
        {displayMoreMembersAvatar && (
          <div
            className={cx(
              'h-9 w-9 rounded-full flex justify-end items-center text-white text-[9px] bg-black ml-1.25',
              additionalCount >= 100 ? 'pr-1' : 'pr-1.75',
            )}
          >
            +{additionalCount}
          </div>
        )}
      </div>
      <p className='text-sm font-semibold'>{totalCount} professionals in this cohort</p>
    </div>
  );
};
